// Steps/Contact.js

import { useForm } from "react-hook-form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAppState } from "../state";

import { Button, Field, Checkbox, Form, Input } from "../Forms/";
import axios from "axios";
import React, { useState, useEffect } from "react";
import Modal from "../Modal/Modal";
import Expansion from "./Expansion";

export const Stand = () => {
    const [state, setState] = useAppState();
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState(false);
    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState(false);
    const [square, setSquare] = useState(null);
    const surfaceValue = state.surfaceValue || "";

    const setModal = (data) => {
        setModalData({ ...data, title: data[0], content: data[1] });
    };

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({ defaultValues: state, mode: "onSubmit" });

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const squareValueFromQuery = queryParams.get("id");
        const squareValueAsNumber = parseInt(squareValueFromQuery, 10);

        if(!squareValueFromQuery && !state.square) {
            fetchOptions(0)
        }
    }, [])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const squareValueFromQuery = queryParams.get("id");
        const squareValueAsNumber = parseInt(squareValueFromQuery, 10);

        if (!isNaN(squareValueAsNumber)) {
            setSquare(squareValueAsNumber);
        }

        // Fetch options based on the square value from the querystring
        if (squareValueAsNumber) {
            fetchOptions(squareValueAsNumber);
        }
    }, [location.search]);
    const fetchOptions = (squareValue) => {
        setIsLoading(true);
        axios
            .post("/wp-json/Qlic/v1/stages/index", {
                stage: squareValue,
            })
            .catch((e) => {
                setIsLoading(false);
            })
            .then((response) => {
                const options = response.data;
                setState({ ...state, options: options, square: square });
                setIsLoading(false);
            });
    };

    const saveData = (data) => {
        setState({ ...state, ...data, stand: state.stand, options: state.options, square: (square ? square : data.square) });
        navigate("/gegevens");
    };

    const handleChange = (event)  => {
        handleLabel(event);
        setIsLoading(true);
        axios.post("/wp-json/Qlic/v1/stages/index", {
            stage: event.target.value
        })
            .catch((e) => {
                setIsLoading(false);
            })
            .then((response) => {
                const options = response.data
                setState({ ...state, options: options, square: square} );
                setIsLoading(false);
            });
    }

    function handleLabel(evt) {
        const targetValue = evt.target.value;
        setValue({
            ...value,
            [evt.target.name]: targetValue
        });
    }

    function optionComponent(props, index) {
        let price = props.price;
        let contribution = props.contribution;
        let modalContent = JSON.parse(props.modal_content);
        let expansionModalContent = null;

        if (props.add_expansion) {
            expansionModalContent = JSON.parse(props.expansion_modal_content);
        }

        const isSurfaceActive = () => {
            if (!props.add_surface) {
                return false;
            }
            return true;
        }

        // Creating a custom field for the Surface React form to allow multiple onClick handlers for the "surface" state.
        // Normally, React only supports one onClick handler per field. This workaround enables handling multiple onClick events.
        const field = (state.stand == index && isSurfaceActive()) ? register("surface", {
            required: "Oppervlakte is verplicht",
            min: props.minimal_surface,
            validate: (value) => value > 0,
        }) : null;


        return (
            <div className="col-12 col-lg-6 mb-4">
                <div className={`stand__item ${state.stand == index ? "stand-is-active" : ""}`}>
                    <div
                        className="stand__item__inner"
                        onClick={() => {
                            // Settings the value in the global state. This is not resetted when this component is unmounted
                            setState({ ...state, stand: index, selectedExpansions: [] });
                        }}
                    >
                        <div className="stand__item__top d-flex align-items-start justify-content-between">
                            {modalContent ?
                                <a onClick={() => setShow(true) & setModal([props.title, modalContent])}><i className="fa-solid fa-square-info"></i>Bekijk details</a>
                                : ''}
                            <span className="stand__trigger"><i className="fa-solid fa-check"></i></span>
                            {state.stand === index && (
                                <Input
                                    {...register("stand")}
                                    id="stand"
                                    placeholder='Oppervlakte'
                                    type="hidden"
                                    name="stand"
                                    value={index}

                                />
                            )}
                        </div>
                        <div className="stand__item__thumb">
                            <img src={props.thumb} />
                        </div>
                        <div className="stand__item__title">
                            <h4>{props.title}</h4>
                        </div>
                        <div className="stand__item__bottom">
                            {props.included && (
                                <div className="stand__item__bottom-specs">
                                    <span>Inbegrepen</span>
                                    <ul className="clean">
                                        {props.included.map((item) => (
                                            <li><i className="fa-sharp fa-solid fa-circle-check"></i>{item.title}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <div className="stand__item__bottom-price">
                                <span>{price}</span>
                                <span>{contribution}</span>
                            </div>
                        </div>
                    </div>
                    {state.stand == index && isSurfaceActive() ?
                        <div className="stand__item__field">
                            <div className="form__field">
                                <Input
                                    {...field}
                                    id="surface"
                                    placeholder='Oppervlakte'
                                    onChange={(e) => {
                                        setState({ ...state, surfaceValue: e.target.value });
                                        field.onChange(e)
                                    }}
                                />
                                <span>min. {props.minimal_surface}m&#178;</span>
                            </div>
                            <div className="unit">m&#178;</div>
                            {errors.surface && <small className="error">Oppervlakte is onjuist</small>}
                        </div>
                        : ''}
                    {state.stand == index && props.add_expansion && (
                        <Expansion
                            stand={props}
                            register={register}
                            setModal={setModal}
                            setShow={setShow}
                            setState={setState}
                            state={state}
                            surface={surfaceValue}
                        />
                    )}
                </div>
            </div>
        )
    }

    return (
        <div className="checkout__form__step" data-form="1">
            <Form onSubmit={handleSubmit(saveData)}>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <h5>Maak een keuze</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Field label="Plein" error={errors?.square} className={square ? 'active select': 'select'}>
                            <select
                                name="square"
                                id="square"
                                {...register("square", {
                                    required: "Kies een type stand",
                                    onChange: (e) => handleChange(e)
                                })}>
                                {stands.map((stand) => (
                                    <option value={stand.id} selected={square == stand.id}>{stand.title}</option>
                                ))}
                            </select>
                        </Field>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <h5>Kies jouw standbouw</h5>
                    </div>
                </div>
                <div className="stand">
                    <div className="row gx-4">
                        {state.options && state.options.length > 0 && state.options.map((option, index) => {
                            return optionComponent(option, index);
                        })}
                    </div>
                </div>

                {state.stand || state.stand == 0  ?
                    <div className="row">
                        <div className="col-12 mt-2">
                            <h4>Bijzonderheden</h4>
                            <Field label="Bijzonderheden (optioneel)" className={value.specialNotes ? 'active': ''}>
                                <Input
                                    {...register("specialNotes", { onChange: (e) => handleLabel(e) })}
                                    id="specialNotes"
                                    placeholder='Bijzonderheden (optioneel)'

                                />
                            </Field>
                        </div>
                        <div className="col-12">
                            <div className="checkout__form__actions d-flex align-items-center justify-content-between mt-3">
                                <Button>Volgende stap</Button>
                            </div>
                        </div>
                    </div>
                    : ''}
            </Form>

            <Modal title={modalData.title} content={modalData.content} onClose={() => setShow(false)} show={show}/>
        </div>
    );
};
